module.exports = __webpack_public_path__ + "d308073b/img/menu-icon.5f8facae.svg";